import { getState } from '@@/store';
import api from './api';
import createAPI from './create-api';
/**
 * 菜单操作相关接口
 * @returns
 */
export function fetchMenuList() {
    return api.getJson('platformController/list.json');
}
export function addOneMenu(payload) {
    return api.postForm('platformController/insert.json', payload);
}
export function delOneMenu(payload) {
    return api.postForm('platformController/deletePlatform.json', payload);
}
export function updateOneMenu(payload) {
    return api.putForm('platformController/update.json', payload);
}
export function updateSequence(payload) {
    return api.putForm('platformController/updateSequece.json', payload);
}
export function updateNotify(payload) {
    return api.putJson('platformController/updateNotify.json', payload);
}
/**
 * 公告相关接口
 */
export function addNotice(params) {
    return api.postJson(`/noticeController/insert.json`, params);
}
export function updateNotice(params) {
    return api.putJson(`/noticeController/update.json`, params);
}
export function deleteNotice(id) {
    return api.postJson(`/noticeController/deleteNotice.json?id=${id}`);
}
export function getPageNotice(page, pageSize) {
    return api.getJson(`/noticeController/getPage.json?page=${page}&pageSize=${pageSize}`);
}
export function getUsefulNotice() {
    return api.getJson(`/noticeController/useful.json`);
}
/**
 * 自定义菜单相关接口
 */
export function addCustomMenu(params) {
    return api.postJson(`/customMenuController.json`, params);
}
export function deleteCustomMenu(id) {
    return api.deleteJson(`/customMenuController.json?id=${id}`);
}
export function getCustomMenu() {
    return api.getJson('/customMenuController.json');
}
// 埋点
const analysisApi = createAPI(process.env.MUJI_APP_API_HELP, {
    showNotification: false,
});
export function sendTrace(metaId) {
    return analysisApi.postJson(`/dailydata`, {
        "metaId": metaId,
        "createdName": getState().global.sso.userInfo.displayName,
        "createdEmail": getState().global.sso.userInfo.email,
        "env": process.env.MUJI_APP_ENV
    });
}
